import { api, ApiTags } from '../../api';
import type { GetUserByLoginOrPublicIdRequest, GetUserByLoginOrPublicIdResponse } from './types';

/**
 * API сервис для работы с пользователями
 */
const userApi = api.injectEndpoints({
    endpoints: build => ({
        /**
         * Получает данные пользователя по login или publicId
         */
        getUserByLoginOrPublicId: build.query<GetUserByLoginOrPublicIdResponse, GetUserByLoginOrPublicIdRequest>({
            query: ({ loginOrPublicId }) => `/users/${loginOrPublicId}`,
            providesTags: (result, error, { loginOrPublicId }) => [{ type: ApiTags.Users, id: loginOrPublicId }],
        }),
    }),
});

export const { useGetUserByLoginOrPublicIdQuery } = userApi;
export * from './types';
